import { TYPE_DATE_COMPARISON } from './input-types';

export const id = 'processedDateTime';
export const apiKey = 'ProcessedDateTime';
export const type = TYPE_DATE_COMPARISON;

export const processedDateTime = {
  id,
  apiKey,
  type,
};
